const TARGET_KEYS = ['scope', 'product', 'service', 'category', 'domain', 'module'];

/**
 * Contexto de serviço de um componente aninhado em um AutoForm.
 *
 * O componente herda o contexto do formulário pai apenas para o que NÃO declarou. O destino declarado no próprio
 * componente (`product/service/category/domain/module`, ou `context`) vence o herdado: um DataGrid de outro módulo
 * embutido no formulário (ex.: perfis do Security dentro do cadastro de tenant) precisa consultar o seu owner.
 */
export function resolveNestedServiceContext(inherited = {}, field = {}) {
  const explicit = {};
  for (const key of TARGET_KEYS) {
    const value = String(field?.[key] ?? '').trim();
    if (value) explicit[key] = value;
  }
  const own = field?.context && typeof field.context === 'object' ? field.context : {};
  const merged = { ...(inherited && typeof inherited === 'object' ? inherited : {}), ...explicit, ...own };
  // `service` e `category` caminham juntos: declarar só um deles no componente não pode manter o outro do pai.
  if (explicit.service && !explicit.category && !own.category) merged.category = explicit.service;
  if (explicit.category && !explicit.service && !own.service) merged.service = explicit.category;
  return merged;
}
